import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Box } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DashboardCard from '../../Components/DashboardCard';
import CommuteIcon from '@material-ui/icons/Commute'; //train
import {
  FaCashRegister,
  FaUserTie,
  FaUserCog,
  FaMoneyBill,
} from 'react-icons/fa';
import { MdLocalLibrary } from 'react-icons/md';
import AppBar from '../../Components/Header/newIndex';
import context from '../../Utils/context';
import { getDashboardCardArray } from '../../Utils/dashboardCards';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.KenColors.background,
    [theme.breakpoints.between('sm', 'md')]: {
      height: '100vh',
    },
  },

  root: {
    minHeight: 220,
    '&:hover': {
      cursor: 'pointer',
    },
  },

  outerWrap: {
    alignItems: 'center',
    margin: theme.spacing(3),
    backgroundColor: theme.palette.KenColors.kenWhite,
  },
  title: {
    fontSize: 20,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  description: {
    fontSize: 14,
  },
  adminPanel: {
    fontSize: 32,
    fontWeight: 'bold',
    textAlign: 'center',
    width: '100%',
  },
  insideContain: {
    // margin: '0 auto',
    backgroundColor: theme.palette.KenColors.kenWhite,
    padding: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
    },
  },
  spacing: {
    // padding: theme.spacing(2),
    [theme.breakpoints.between('sm', 'md')]: {
      padding: '5px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '3px',
    },
  },
}));

const DashboardPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const { config } = React.useContext(context);
  const logo = config?.logo;

  const handleClick = () => {
    history.push('/app/home');
  };

  return (
    <div className={classes.container}>
      <Box height="68px">
        <AppBar
          logo={logo}
          title="UNIFIED PORTAL"
          handleClick={handleClick}
          history={history}
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          cards={getDashboardCardArray(t)}
          config={config}
        />
      </Box>
      <div className={classes.outerWrap}>
        <Box>
          <Grid container className={classes.insideContain} spacing={2}>
            {getDashboardCardArray(t).map((item, index) => {
              return (
                <Grid
                  item
                  md={3}
                  sm={6}
                  xs={6}
                  key={index}
                  className={classes.spacing}
                >
                  <DashboardCard {...item}></DashboardCard>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </div>
    </div>
  );
};

export default DashboardPage;
